<mat-icon (click)="openCloneUsesPopup()">content_copy</mat-icon>
